import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=a2af71e6&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=a2af71e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2af71e6",
  null
  
)

export default component.exports